import type { ApolloError } from '@apollo/client';
import type { GraphQLError } from 'graphql';

/** True when a single GraphQL error is an authorization denial. */
export const isAuthorizationGraphQLError = (error: GraphQLError): boolean => {
  let maybeJSONMessage: any;
  try {
    maybeJSONMessage = JSON.parse(error.message);
  } catch {}
  return (
    error?.extensions?.code === 'FORBIDDEN' ||
    maybeJSONMessage?.code === 'NOT_AUTHORIZED'
  );
};

/** True when an ApolloError carries at least one authorization denial. */
export const isAuthorizationError = (error?: ApolloError): boolean =>
  error?.graphQLErrors?.some(isAuthorizationGraphQLError) ?? false;
